import { render, staticRenderFns } from "./App.vue?vue&type=template&id=9f75f264&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/bootstrap-grid.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/globel.css?vue&type=style&index=1&lang=css&"
import style2 from "./App.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports